import { gsap } from "gsap";
import { Settings } from "../Constants";
import { Renderer, ResizeEvent } from "../renderer/Renderer";
import { OrientationType } from "../renderer/constant/RendererConstants";
import { AbstractGameController } from "./AbstractGameController";
/**
 * OrientationController.ts
 */
export class OrientationController extends AbstractGameController {
    create() {
        super.create();
        this.renderer = Renderer.getInstance();
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(ResizeEvent.PRE_ROTATE, this.handleRotate);
    }
    handleRotate() {
        if (this.renderer.getOrientation() === OrientationType.LANDSCAPE) {
            this.renderer.updateProperties(this.baseFactory.getLandscapeViewport());
        }
        else {
            this.renderer.updateProperties(this.baseFactory.getPortraitViewport());
        }
        this.renderer.getHolder().visible = false;
        this.dispatchCore(ResizeEvent.ROTATE);
        this.renderer.forceResize();
        this.renderer.getHolder().visible = true;
        if (this.postRotateTimer) {
            this.postRotateTimer.kill();
        }
        this.postRotateTimer = gsap.delayedCall(Settings.POST_ROTATE_DELAY, async () => {
            await this.dispatchBlockingEvent(ResizeEvent.REINITIALISE_TEXT);
            this.dispatchCore(ResizeEvent.POST_ROTATE);
            this.postRotateTimer = null;
            this.dispatchCore(ResizeEvent.TRACK_TARGETS);
        });
    }
}
//# sourceMappingURL=OrientationController.js.map